import HttpBase from '@/services/base/HttpBase'
import { username } from '@/config.js';
import { password } from '@/config.js';



export default class LoginService  extends HttpBase {
    constructor() {
        super('', 3)
    }
   
    async efetuaLogin() {
        var obj = `{"username": "`+ username +`", "password": "`+ password +`" }`;
        return this.post('', obj);
    }
}